import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyToken } from "../api/client";
import { useAuth } from "../context/AuthContext";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");
  // Sentinel: React 18 <StrictMode> double-invokes effects in development.
  // The token is single-use server-side, so the second invocation would 400
  // with "Token already used". Guard so verifyToken fires exactly once.
  const submittedRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setError("No token provided.");
      return;
    }
    if (submittedRef.current) return;
    submittedRef.current = true;
    verifyToken(token)
      .then(() => {
        refresh();
        navigate("/", { replace: true });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "Verification failed.");
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded shadow max-w-sm w-full text-center">
          <h1 className="text-xl font-semibold mb-2 text-red-600">Login failed</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <a href="/login" className="text-blue-600 underline text-sm">
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-500">Verifying your login…</p>
    </div>
  );
}
